import { render, staticRenderFns } from "./AmlBlackListView.vue?vue&type=template&id=5f8217c9&"
import script from "./AmlBlackListView.vue?vue&type=script&lang=js&"
export * from "./AmlBlackListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports